export default __webpack_public_path__ + "static/media/hp-plans-condition-explorer-img.4453a15a.svg";